<template>
  <mu-card>
    <mu-list-item v-if="isLoading === true" v-for="item, index in params.per_page" :key="'params-' + index">
      <mu-linear-progress slot="describe" color="#d9d9d9"
                          style="width: 50%; height: 14px;background: rgb(214, 214, 214); margin-bottom: 8px"></mu-linear-progress>
      <mu-avatar
        :src="item.avatar"
        slot="left"
        color="white"
        backgroundColor="white"
      >
      </mu-avatar>
      <div slot="describe">
        <mu-linear-progress color="#d9d9d9" style="height:12px; width: 15%; background: #f1f1f1"></mu-linear-progress>
      </div>
    </mu-list-item>
    <mu-list v-if="isLoading === false && hasItems">
      <mu-list-item class="userQuestion" v-for="item, itemIndex in items" :key="'question-item-' + itemIndex"
                    :to="{path: `/questions/thread/${item.question_id}`}">
        <div slot="title" class="title">
          <p class="question-title" v-html="$sanitize(item.question)"></p>
          <p class="question-by">
            {{$t('message.discussionAskedBySuffix')}}
            <router-link :to="{path: `/profile/${item.url}`}" v-text="item.display_name"/>
          </p>
        </div>
        <mu-avatar :src="item.profile_large" slot="leftAvatar"/>
        <div slot="describe">
          <span class="date" v-text="fromNow(item.timestamp)"></span>
        </div>
      </mu-list-item>
    </mu-list>
    <mu-card-text v-if="!isLoading && !hasItems">{{$t('message.labelNo')}} {{ type === 'MY_QUESTIONS' ? $t('message.labelQuestionsAsked').toLowerCase() : $t('message.labelQuestionsAnswered').toLowerCase()}}</mu-card-text>
  </mu-card>
</template>
<script>

  import DiscussionApi from "../../../api/Discussion";
  import Config from "../../../config/";
  import MuCardText from "../../../../node_modules/muse-ui/src/card/cardText";

  export default {
    components: {MuCardText},
    name: "user-profile-questions",
    props: {
      type: {
        type: String,
        required: true,
        default: "MY_QUESTIONS"
      },
      userId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        isLoading: true,
        items: [],
        params: {
          page: 1,
          per_page: 5,
          type: "",
          user_id: 0
        }
      }
    },
    methods: {
      fromNow(date) {
        return Config.dateFormatting.fromNow(date);
      },
      loadQuestions() {
        let self = this;
        self.params.type = self.type;
        self.params.user_id = self.userId;
        DiscussionApi.getDiscussionQuestions(self.params).then((response) => {
          self.isLoading = false;
          self.items = response.data.questions;
        }).catch((error) => {
          self.isLoading = false;
        });
      },
      initMounted() {
        let self = this;
        self.loadQuestions();
      }
    },
    computed: {
      hasItems() {
        let self = this;
        return self.items.length > 0 ? true : false;
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
    }
  }

</script>



// WEBPACK FOOTER //
// UserQuestions.vue?5e412836